import { useNavigate } from 'react-router-dom'
import { Button, Card, CardColors, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const CreateAllocationCard = () => {
  const navigate = useNavigate()

  return (
    <Card color={CardColors.EMPHASIS}>
      <Text variant={TypographyStyles.H2}>Set up your Allocation Guide</Text>
      <br />
      <Text variant={TypographyStyles.LABEL_MD}>
        <b>Want more guidance on how to allocate your earnings?</b>
      </Text>
      <br />
      <Text variant={TypographyStyles.BODY_MD}>
        Set up your Allocation Guide to determine how much to set aside for
        taxes, retirement, paychecks and more. We&apos;ll send over a
        &#34;paystub&#34; at the end of every month with suggested amounts based
        on your previous months&apos; earnings.
      </Text>
      <br />
      <Button
        variant="primary"
        className="max-w-80"
        onClick={() => navigate('/allocation-guides/new')}
      >
        Start
      </Button>
    </Card>
  )
}
